import { isActiveProduct, type Product } from '../../../../data/product';

export type MutedReason = 'disabled' | 'no recent sales';

export function mutedReason(product: Product): MutedReason | null {
  if (isActiveProduct(product)) {
    return null;
  }

  return product.disabled || product.auto_disabled ? 'disabled' : 'no recent sales';
}

export function MutedBadge({ reason }: { reason: MutedReason }) {
  return (
    <span
      className={`mt-0.5 inline-block rounded px-1 py-0.5 text-[10px] font-semibold uppercase ${
        reason === 'disabled' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'
      }`}
    >
      {reason}
    </span>
  );
}
